<template>
  <div>
    <vue-headful
      title="VARELAB - Laboratorio de Análisis Clínicos"
      description="Somos un laboratorio de análisis clínicos con más de 12 años de trayectoria en el mercado. Nos especializamos en extracciones pediátricas y... ver más"
    />
    <section class="front text-right">
      <div class="bg-parallax" v-parallax="0.2"></div>
      <div class="container">
        <h1 class="title title--big color--blue">
          Cuidando <br />
          tu salud
        </h1>
        <div class="text-right">
          <div class="separator separator--blue"></div>
        </div>
        <h2 class="color--red text-uppercase">
          La tranquilidad de saber <br />
          que estas en buenas manos
        </h2>
      </div>
    </section>

    <div class="actions">
      <div class="container">
        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <div class="row">
              <div class="col-xs-12 col-sm-4 col-sm-offset-0">
                <div class="actions__block">
                  <div class="icon icon-studies"></div>
                  <h3>
                    ¿Que estudios <br />
                    realizamos?
                  </h3>
                  <div class="text-center">
                    <div class="separator separator--white"></div>
                  </div>
                  <p>Conocé la amplia gama de estudios y su preparación</p>
                  <router-link to="/servicios/estudios">Buscar</router-link>
                </div>
              </div>
              <div class="col-xs-12 col-sm-4 col-sm-offset-0">
                <div class="actions__block">
                  <div class="icon icon-order"></div>
                  <h3>
                    ¿Dudas con tu <br />
                    orden médica?
                  </h3>
                  <div class="text-center">
                    <div class="separator separator--white"></div>
                  </div>
                  <p>Adjuntanos tu orden médica y te asesoramos</p>
                  <router-link to="/servicios/dudas"
                    >Adjuntar orden</router-link
                  >
                </div>
              </div>
              <div class="col-xs-12 col-sm-4 col-sm-offset-0">
                <div class="actions__block">
                  <div class="icon icon-question"></div>
                  <h3>
                    Preguntas <br />
                    Frecuentes
                  </h3>
                  <div class="text-center">
                    <div class="separator separator--white"></div>
                  </div>
                  <p>Acercanos tus consultas y despejamos cualquier duda</p>
                  <router-link to="/servicios/preguntas">Consultar</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="about">
      <div class="container">
        <div class="row">
          <div class="col-sm-10 col-sm-offset-1">
            <div class="about__inner">
              <div class="row">
                <div class="col-sm-8">
                  <div class="relative">
                    <h2 class="title color--blue">Varelab, tu lugar</h2>
                    <br />
                    <div class="separator separator--red"></div>
                    <h3 class="color--light-blue">
                      Somos un laboratorio de análisis clínicos con una amplia
                      trayectoria en el mercado desde el año 2005. Nos
                      especializamos en extracciones pediátricas y geriátricas,
                      brindándole a los pacientes el mejor servicio, gracias a
                      la constante innovación en recursos tecnológicos y al
                      equipo de profesionales altamente capacitado con el que
                      contamos.
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="feed">
      <div class="container">
        <div v-if="showPosts" v-cloak>
          <div class="row" v-for="i in Math.ceil(posts.length / 3)">
            <div
              class="col-sm-4"
              v-for="post in posts.slice((i - 1) * 3, i * 3)"
            >
              <a :href="post.link" class="feed__block" target="_blank">
                <div
                  class="feed__image hidden"
                  :style="{ backgroundImage: 'url(\'' + post.image + '\')' }"
                ></div>
                <img
                  :src="post.image"
                  alt="Novedades Varelab"
                  class="img-responsive"
                />
                <div class="feed__content feed__content--inverse">
                  <p v-html="post.title"></p>
                  <hr />
                </div>
              </a>
            </div>
          </div>
        </div>
        <div v-else>Cargando ...</div>
      </div>
    </div>

    <div class="information" id="contacto">
      <div class="container">
        <div class="row">
          <div class="col-sm-4 information__block">
            <div class="text-center">
              <div class="icon icon-clock"></div>
              <h2>Horario de atención</h2>
              <p>
                Lunes a Viernes de 8 a 17 hs. <br />
                (horario de corrido)
              </p>
            </div>
          </div>
          <div class="col-sm-4 information__block">
            <div class="text-center">
              <div class="icon icon-contact"></div>
              <h2>Vías de contacto</h2>
              <p>
                4287-6172 <br />
                <a class="color--blue" href="mailto:info@varelab.com.ar"
                  >info@varelab.com.ar</a
                >
              </p>
            </div>
          </div>
          <div class="col-sm-4 information__block">
            <div class="text-center">
              <div class="icon icon-credit"></div>
              <h2>Efectivo y otros medios de pago</h2>
              <img
                src="../assets/img/tarjetas.png"
                alt=""
                class="img-responsive center-block"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <gmap-map
      :center="center"
      :zoom="16"
      :options="mapStyle"
      map-type-id="terrain"
      style="width: 100%; height: 400px"
      class="map"
    >
      <gmap-marker
        :position="center"
        :icon="require('../assets/img/marker.png')"
        :clickable="true"
        :draggable="false"
        @click="center = m.position"
      ></gmap-marker>
    </gmap-map>

    <div class="bg--boston-blue p-15">
      <div class="text-center color--white fz-22">
        <span class="montserrat"
          >¿TE GUSTARÍA FORMAR PARTE DEL EQUIPO DE VARELAB?</span
        >
        <a
          href="#"
          data-toggle="modal"
          data-target="#cvModal"
          class="button button--vogue text-uppercase fz-17 m-left-20 m-right-20"
          >Dejanos tu CV</a
        >
      </div>
    </div>
  </div>
</template>

<script>
var mapStyle = [
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: "#e9e9e9"
      },
      {
        lightness: 17
      }
    ]
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [
      {
        color: "#f5f5f5"
      },
      {
        lightness: 20
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#ffffff"
      },
      {
        lightness: 17
      }
    ]
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#ffffff"
      },
      {
        lightness: 29
      },
      {
        weight: 0.2
      }
    ]
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff"
      },
      {
        lightness: 18
      }
    ]
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [
      {
        color: "#ffffff"
      },
      {
        lightness: 16
      }
    ]
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      {
        color: "#f5f5f5"
      },
      {
        lightness: 21
      }
    ]
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: "#dedede"
      },
      {
        lightness: 21
      }
    ]
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        visibility: "on"
      },
      {
        color: "#ffffff"
      },
      {
        lightness: 16
      }
    ]
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        saturation: 36
      },
      {
        color: "#333333"
      },
      {
        lightness: 40
      }
    ]
  },
  {
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off"
      }
    ]
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [
      {
        color: "#f2f2f2"
      },
      {
        lightness: 19
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#fefefe"
      },
      {
        lightness: 20
      }
    ]
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#fefefe"
      },
      {
        lightness: 17
      },
      {
        weight: 1.2
      }
    ]
  }
];

export default {
  name: "home",
  data() {
    return {
      posts: false,
      center: { lat: -34.810301, lng: -58.264848 },
      showPosts: false,
      mapStyle: {
        styles: mapStyle,
        disableDefaultUI: true
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    // Hacemos el fetch de la informacion del feed antes de cargar la ruta
    next(vm => vm.getPosts());
  },
  methods: {
    getPosts: function() {
      this.$http
        .get("http://www.varelab.com.ar/api/public/api/feed/facebook/3")
        .then(function(response) {
          this.posts = response.data;
          this.showPosts = true;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue